<template>
  <section class="navHeader">
    <div class="container-nav">
      <div class="navHeader__flex">
        <div class="navHeader__left">
          <div class="navHeader__logo">
            <div class="navHeader__burger" @click="openMenu()">
              <img src="../../assets/images/menu.svg" alt="">
            </div>
            <i class="close-nav" v-if="showMenu" @click="closeMenu()" :class="{ 'show': showMenu }" ></i>
            <div class="mobile-nav" :class="{ 'show': showMenu }">
              <div class="top-mm">
                <ul itemscope itemtype="http://schema.org/SiteNavigationElement" class="nav-mm">
                  <li><a itemprop="url" :href="`/${locale_}/`" >{{$t('qic_landing_header_main_mobile_title')}}</a></li>
                  <LandingHeaderMobileItem
                    v-for="(app, index) of appNamesOrder"
                    :key="index"
                    :appInfo="appsList[app]"
                    :title="getAppTitle(app)"
                    :locale="locale_"/>
                </ul>
              </div>
              <a itemprop="url" :href="`/${locale_}/insurance-renewal`" class="navHeader__renewBtn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 4C2.55228 4 3 4.39175 3 4.875V9.25H8C8.55228 9.25 9 9.64175 9 10.125C9 10.6082 8.55228 11 8 11H2C1.44772 11 1 10.6082 1 10.125V4.875C1 4.39175 1.44772 4 2 4Z" fill="#5927FF"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1598 2.08779C13.014 1.81593 14.9029 2.17941 16.5417 3.12343C18.1805 4.06746 19.4805 5.54091 20.2457 7.32177C21.011 9.10262 21.2002 11.0944 20.7847 12.997C20.3692 14.8996 19.3715 16.61 17.9421 17.8704C16.5126 19.1308 14.7288 19.873 12.8594 19.9851C10.9899 20.0972 9.13613 19.5732 7.57734 18.492C6.01855 17.4108 4.83918 15.831 4.21695 13.9907C4.05844 13.5218 4.29466 13.0079 4.74456 12.8427C5.19446 12.6776 5.68767 12.9237 5.84617 13.3925C6.34396 14.8648 7.28745 16.1287 8.53449 16.9936C9.78152 17.8586 11.2645 18.2778 12.7601 18.1881C14.2557 18.0984 15.6827 17.5047 16.8263 16.4963C17.9699 15.488 18.768 14.1197 19.1004 12.5976C19.4328 11.0755 19.2814 9.4821 18.6692 8.05741C18.057 6.63273 17.017 5.45397 15.706 4.69875C14.3949 3.94352 12.8838 3.65275 11.4004 3.87023C9.917 4.08771 8.54159 4.80167 7.48143 5.90454C7.47527 5.91095 7.46901 5.91726 7.46266 5.92348L3.45513 9.84748C3.10751 10.1878 2.56092 10.1701 2.23428 9.8079C1.90764 9.44567 1.92464 8.87609 2.27226 8.53572L6.27052 4.6208C7.59443 3.24783 9.30991 2.35899 11.1598 2.08779Z" fill="#5927FF"/>
              </svg>
                {{$t('qic_landing_header_renew')}}
              </a>
              <div class="bottom-mm">
                <div class="num-phone">
                  <a href="tel:8 000 742">8 000 742</a>
                  <span>{{$t('qic_landing_footer_hotline')}}</span>
                </div>
              </div>
              <a itemprop="url" href="https://api.whatsapp.com/send/?phone=97450000742&text&app_absent=0" class="mobile-nav__whatsapp">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.4988 14.382C17.1994 14.233 15.7313 13.515 15.458 13.415C15.1847 13.316 14.9858 13.267 14.7858 13.565C14.5869 13.861 14.0151 14.531 13.8413 14.729C13.6665 14.928 13.4926 14.952 13.1942 14.804C12.8958 14.654 11.9332 14.341 10.7927 13.329C9.90544 12.541 9.30557 11.568 9.13173 11.27C8.9579 10.973 9.11264 10.812 9.26236 10.664C9.39701 10.531 9.56079 10.317 9.71051 10.144C9.86022 9.97002 9.90946 9.84602 10.0089 9.64703C10.1094 9.44903 10.0592 9.27603 9.98382 9.12703C9.90946 8.97803 9.3126 7.51503 9.06341 6.92003C8.82125 6.34103 8.57507 6.42003 8.39219 6.41003C8.21736 6.40203 8.0184 6.40003 7.81945 6.40003C7.6205 6.40003 7.29695 6.47403 7.02364 6.77203C6.74932 7.06903 5.97863 7.78803 5.97863 9.25103C5.97863 10.713 7.04775 12.126 7.19747 12.325C7.34719 12.523 9.30255 15.525 12.2979 16.812C13.0113 17.118 13.567 17.301 14.0001 17.437C14.7155 17.664 15.3666 17.632 15.8811 17.555C16.4538 17.47 17.6475 16.836 17.8967 16.142C18.1449 15.448 18.1449 14.853 18.0705 14.729C17.9962 14.605 17.7972 14.531 17.4978 14.382H17.4988ZM12.0507 21.785H12.0467C10.2676 21.7853 8.52118 21.3094 6.99048 20.407L6.62875 20.193L2.86874 21.175L3.87255 17.527L3.63642 17.153C2.64179 15.5774 2.11543 13.7538 2.11814 11.893C2.12015 6.44303 6.57549 2.00904 12.0547 2.00904C14.7074 2.00904 17.2014 3.03904 19.0764 4.90703C20.0012 5.82361 20.7342 6.9136 21.233 8.11392C21.7318 9.31425 21.9864 10.6011 21.9823 11.9C21.9803 17.35 17.5249 21.785 12.0507 21.785ZM20.5032 3.48804C19.3961 2.37896 18.0788 1.49958 16.6277 0.90084C15.1766 0.302104 13.6206 -0.00407624 12.0497 4.09775e-05C5.46417 4.09775e-05 0.102491 5.33503 0.100481 11.892C0.0994764 13.988 0.649109 16.034 1.69512 17.837L0 24L6.33434 22.346C8.0866 23.2961 10.0502 23.794 12.0457 23.794H12.0507C18.6363 23.794 23.9979 18.459 23.9999 11.901C24.0048 10.3383 23.6983 8.79013 23.0981 7.34606C22.4978 5.902 21.6159 4.5907 20.5032 3.48804Z" fill="#526C82" fill-opacity="0.8"/>
                </svg>
                  {{$t('qic_landing_footer_wa_chat')}}
              </a>
            </div>
            <div class="overlay-nav" @click="closeMenu()" v-show="showMenuBg" :class="{ 'show': showMenu }"></div>
            <div class="logo">
              <a :href="`/${locale_}/`">
                <img src="../../assets/images/logo.svg" alt="logo qic travel insurance">
                <div class="logo_add car">
                  <span>{{ $t('logo_first_line') }}</span>
                  <i class="logoArrow"></i>
                  <span>{{ $t('logo_second_line') }}</span>
                </div>
              </a>
            </div>
          </div>
          <ul itemscope itemtype="http://schema.org/SiteNavigationElement" class="navHeader__menu">
            <LandingHeaderDesktopItem
              v-for="(app, index) of appNamesOrder"
              :key="index"
              :appInfo="appsList[app]"
              :active="app === appName"
              :title="getAppTitle(app)"
              :locale="locale_"/>
            <li class="navHeader__more" >
              <button type="button" @click.prevent="showMobile=!showMobile; $event.target.focus()" @blur="showMobile=false" >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="6" r="1.5" fill="#1C1C1C"/>
                <circle cx="12" cy="12" r="1.5" fill="#1C1C1C"/>
                <circle cx="12" cy="18" r="1.5" fill="#1C1C1C"/>
                </svg>
              </button>
              <ul v-if="showMobile" class="dropdown-menu" @mousedown.prevent>
                <li
                  v-for="(app, index) of appNamesOrder.slice(appNamesOrder.length - 2)"
                  :key="index">
                  <a itemprop="url" :href="`/${locale_}/${appsList[app].url}/`">{{$t(appsList[app].headerTitleT)}}</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="navHeader__right">
          <div class="navHeader__btn-group">
              <a href="#" class="navHeader__claimsBtn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mob-off">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3982 1.08275C13.8054 1.25952 14.0474 1.68359 13.9923 2.12409L13.1328 9.00006H21C21.388 9.00006 21.741 9.22452 21.9056 9.5759C22.0702 9.92729 22.0166 10.3422 21.7682 10.6402L11.7682 22.6402C11.484 22.9813 11.009 23.0941 10.6018 22.9174C10.1946 22.7406 9.95267 22.3165 10.0077 21.876L10.8672 15.0001H3.00001C2.61199 15.0001 2.259 14.7756 2.09442 14.4242C1.92984 14.0728 1.98339 13.658 2.23179 13.3599L12.2318 1.35987C12.516 1.01884 12.991 0.905986 13.3982 1.08275ZM5.13505 13.0001H12C12.2868 13.0001 12.5599 13.1232 12.7497 13.3383C12.9395 13.5533 13.0279 13.8395 12.9923 14.1241L12.4154 18.7396L18.865 11.0001H12C11.7132 11.0001 11.4402 10.8769 11.2503 10.6619C11.0605 10.4468 10.9722 10.1606 11.0077 9.87602L11.5847 5.26051L5.13505 13.0001Z" fill="#5927FF"/>
                </svg>
                  {{$t('qic_landing_header_claims')}}
                </a>
            <a itemprop="url" :href="`/${locale_}/insurance-renewal`" class="navHeader__renewBtn">
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M21.2998 5C20.7475 5 20.2998 5.39175 20.2998 5.875V10.25H15.2998C14.7475 10.25 14.2998 10.6418 14.2998 11.125C14.2998 11.6082 14.7475 12 15.2998 12H21.2998C21.8521 12 22.2998 11.6082 22.2998 11.125V5.875C22.2998 5.39175 21.8521 5 21.2998 5Z" fill="#5927FF"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.14 3.08779C10.2858 2.81593 8.39693 3.17941 6.75813 4.12343C5.11934 5.06746 3.81935 6.54091 3.05406 8.32177C2.28876 10.1026 2.09962 12.0944 2.51512 13.997C2.93062 15.8996 3.92826 17.61 5.35771 18.8704C6.78717 20.1308 8.57101 20.873 10.4405 20.9851C12.3099 21.0972 14.1637 20.5732 15.7225 19.492C17.2813 18.4108 18.4606 16.831 19.0829 14.9907C19.2414 14.5218 19.0051 14.0079 18.5552 13.8427C18.1053 13.6776 17.6121 13.9237 17.4536 14.3925C16.9558 15.8648 16.0124 17.1287 14.7653 17.9936C13.5183 18.8586 12.0353 19.2778 10.5397 19.1881C9.04415 19.0984 7.61708 18.5047 6.47351 17.4963C5.32995 16.488 4.53184 15.1197 4.19944 13.5976C3.86704 12.0755 4.01836 10.4821 4.63059 9.05741C5.24283 7.63273 6.28281 6.45397 7.59385 5.69875C8.90489 4.94352 10.416 4.65275 11.8994 4.87023C13.3828 5.08771 14.7582 5.80167 15.8184 6.90454C15.8245 6.91095 15.8308 6.91726 15.8371 6.92348L19.8447 10.8475C20.1923 11.1878 20.7389 11.1701 21.0655 10.8079C21.3922 10.4457 21.3752 9.87609 21.0275 9.53572L17.0293 5.6208C15.7054 4.24783 13.9899 3.35899 12.14 3.08779Z" fill="#5927FF"/>
              </svg>
              {{$t('qic_landing_header_renew')}}
            </a>
          </div>
          <div class="navHeader__hotlang">
            <div class="navHeader__langInline">
              <a :class="{ 'active': locale === 'en' }" :href="getLocaleUrl('en')">Eng</a>
              <a class="arabic_font" :class="{ 'active': locale === 'ar' }" :href="getLocaleUrl('ar')">عربي</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import landgingAppsInfo from '../../assets/maps/landingAppsInfo.json'
import LandingHeaderDesktopItem from './LandingHeaderDesktopItem.vue'
import LandingHeaderMobileItem from './LandingHeaderMobileItem.vue'
export default {
  name: 'LandingHeader',
  props: {
    appName: { type: String, required: true },
    locale: { type: String }
  },
  components: {
    LandingHeaderDesktopItem,
    LandingHeaderMobileItem
  },
  data () {
    return {
      showMenu: false,
      showMenuBg: false,
      showMobile: false,
      currentYear: new Date().getFullYear(),
      appsList: landgingAppsInfo.appsList,
      appNamesOrder: landgingAppsInfo.headerOrder,
      selectLangShow: false
    }
  },
  computed: {
    locale_ () {
      if (this.locale) return this.locale
      return 'en'
    }
  },
  methods: {
    getAppTitle (app) {
      if (this.$te(this.appsList[app].headerTitleT)) {
        return this.$t(this.appsList[app].headerTitleT)
      }
      return this.$t(this.appsList[app].headerTitle)
    },
    openMenu () {
      this.showMenu = true
      this.showMenuBg = true
      const body = document.querySelector('body')
      body.classList.add('overflow-off')
    },
    closeMenu () {
      this.showMenu = false
      setTimeout(() => {
        this.showMenuBg = false
      }, 500)
      const body = document.querySelector('body')
      body.classList.remove('overflow-off')
    },
    getLocaleUrl (locale) {
      const path = new URL(window.location.href).pathname
      if (path.slice(0, 3) === ('/en')) {
        return locale === 'en' ? path : path.replace('/en', '/ar')
      } else {
        return locale === 'ar' ? path : path.replace('/ar', '/en')
      }
    }
  }
}
</script>
